import React from "react"
import SbEditable from "storyblok-react"
import PropTypes from "prop-types"
import linkHandler from "../../helpers/storyblokLinkHandler"

import Anchor from "./anchor"
import ButtonAction from "./button"

const Button = ({
  blok,
  className,
  iconName,
  text,
  href,
  onClick,
  disabled,
}) => {
  if (blok !== null) {
    return (
      <SbEditable content={blok}>
        <Anchor
          label={blok.label}
          href={linkHandler(blok.link)}
          icon={blok.icon}
          className={className}
          button_color={blok.button_color}
          AB_button_cta={blok.AB_button_cta}
          AB_button_cta_mobile={blok.AB_button_cta_mobile}
          target={blok.target || "_self"}
          accessibility_title={blok.accessibility_title}
        />
      </SbEditable>
    )
  }

  if (href !== null) {
    return (
      <Anchor label={text} href={href} icon={iconName} className={className} />
    )
  }

  return (
    <ButtonAction
      label={text}
      className={className}
      icon={iconName}
      onClick={onClick}
      disabled={disabled}
    />
  )
}

Button.defaultProps = {
  blok: null,
  text: "",
  className: "",
  iconName: "",
  href: null,
  onClick: () => {},
  disabled: false,
}

Button.propTypes = {
  blok: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.shape({
      linktype: PropTypes.string,
      cached_url: PropTypes.string,
      url: PropTypes.string,
    }),
    icon: PropTypes.string,
    accessibility_title: PropTypes.string,
    target: PropTypes.string,
    button_color: PropTypes.bool,
    AB_button_cta: PropTypes.bool,
    AB_button_cta_mobile: PropTypes.bool,
  }),
  text: PropTypes.string,
  className: PropTypes.string,
  iconName: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
}

export default Button
